let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5gwtQ")).then(() => parcelRequire('1X9yr'));